import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: /admin/users/* children (e.g. $userId) render through here.
// The user list itself lives at ./users/index.tsx ("/admin/users/").
export const Route = createFileRoute("/admin/users")({
  component: () => <Outlet />,
});
